import { useState, useEffect } from 'react'

function useWindowWidth() {
    // The first browser render must match Gatsby's server HTML.
    const [windowWidth, setWindowWidth] = useState(0)

    useEffect(() => {
        function handleResize() {
            setWindowWidth(window.innerWidth)
        }

        handleResize()
        window.addEventListener('resize', handleResize, { passive: true })

        return () => {
            window.removeEventListener('resize', handleResize)
        }
    }, [])

    return windowWidth
}

export default useWindowWidth
